import { createContext, useContext, useState, useLayoutEffect, type ReactNode } from 'react';

interface PageHeaderState {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  breadcrumbs?: { label: string; href?: string }[];
}

const PageHeaderStateContext = createContext<PageHeaderState | null>(null);
const PageHeaderSetContext = createContext<(state: PageHeaderState | null) => void>(() => {});

export function PageHeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeader] = useState<PageHeaderState | null>(null);

  return (
    <PageHeaderSetContext.Provider value={setHeader}>
      <PageHeaderStateContext.Provider value={header}>
        {children}
      </PageHeaderStateContext.Provider>
    </PageHeaderSetContext.Provider>
  );
}

export function usePageHeader(state: PageHeaderState) {
  const setHeader = useContext(PageHeaderSetContext);

  useLayoutEffect(() => {
    setHeader(state);
    return () => setHeader(null);
  }, [setHeader, state]);
}

export function usePageHeaderState() {
  return useContext(PageHeaderStateContext);
}
